import React from "react";

function PrivacyPolicy() {
  return (
    <section className="py-5 bg-light">
      <div className="container">
        {/* Page Header */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Privacy Policy</h2>
          <p className="text-muted">
            Last updated: August 18, 2026
          </p>
          <p className="text-muted">
            This Privacy Policy explains how Chemo Biological Ltd. collects,
            uses, protects, and discloses your information when you use our
            website and services.
          </p>
        </div>

        {/* Content */}
        <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5">
          <h5 className="fw-semibold mb-3">1. Interpretation and Definitions</h5>
          <p className="text-muted">
            The words with an initial capital letter have meanings defined
            under the following conditions. These definitions apply whether
            the terms appear in singular or plural form.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">2. Definitions</h5>
          <p className="text-muted">
            <strong>Company:</strong> Refers to Chemo Biological Ltd.
          </p>
          <p className="text-muted">
            <strong>Website:</strong> Refers to Chemo Biological Ltd.,
            accessible from www.biologicalchemo.com.
          </p>
          <p className="text-muted">
            <strong>Service:</strong> Refers to the Website and services
            provided through it.
          </p>
          <p className="text-muted">
            <strong>Personal Data:</strong> Any information that relates to an
            identified or identifiable individual.
          </p>
          <p className="text-muted">
            <strong>Usage Data:</strong> Information collected automatically
            through the use of the Website, such as browser information, IP
            address, pages visited, and visit duration.
          </p>
          <p className="text-muted">
            <strong>Cookies:</strong> Small files stored on your device that
            help us improve website functionality and user experience.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            3. Collecting and Using Your Personal Data
          </h5>
          <p className="text-muted">
            While using our Website, we may ask you to provide certain
            personally identifiable information that can be used to contact or
            identify you.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">4. Personal Data</h5>
          <p className="text-muted">
            Personal information collected through our Website may include:
          </p>
          <ul className="text-muted">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Business enquiry details</li>
            <li>Other information voluntarily submitted through our forms</li>
          </ul>

          <h5 className="fw-semibold mt-4 mb-3">5. Usage Data</h5>
          <p className="text-muted">
            Usage Data is collected automatically when you use our Service.
            This may include your device's IP address, browser type, browser
            version, pages visited, date and time of your visit, time spent on
            pages, device identifiers, and other diagnostic information.
          </p>

          <p className="text-muted">
            When you access our Service through a mobile device, we may collect
            information such as your mobile device type, operating system,
            mobile browser type, IP address, unique device identifiers, and
            other diagnostic data.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            6. Tracking Technologies and Cookies
          </h5>
          <p className="text-muted">
            We use Cookies and similar tracking technologies to monitor
            activity on our Website, store certain information, improve
            functionality, and analyze website performance.
          </p>

          <p className="text-muted">
            Cookies may be either <strong>Session Cookies</strong>, which are
            deleted when you close your browser, or{" "}
            <strong>Persistent Cookies</strong>, which remain on your device
            until they expire or are deleted.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            7. Types of Cookies We Use
          </h5>

          <p className="text-muted">
            <strong>Necessary / Essential Cookies:</strong> These cookies are
            required for the Website to function properly and provide certain
            services and features.
          </p>

          <p className="text-muted">
            <strong>Cookies Policy / Notice Acceptance Cookies:</strong> These
            cookies help us remember whether users have accepted the use of
            cookies on the Website.
          </p>

          <p className="text-muted">
            <strong>Functionality Cookies:</strong> These cookies allow us to
            remember choices and preferences made by users to provide a more
            personalized experience.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            8. Use of Your Personal Data
          </h5>
          <p className="text-muted">
            Chemo Biological Ltd. may use your Personal Data for the following
            purposes:
          </p>
          <ul className="text-muted">
            <li>To provide and maintain our Website and services.</li>
            <li>To respond to enquiries and requests submitted by you.</li>
            <li>To contact you regarding products, services, or enquiries.</li>
            <li>To provide information about our products and services.</li>
            <li>To manage business and PCD Pharma Franchise enquiries.</li>
            <li>To improve our Website, products, services, and user experience.</li>
            <li>To analyze website usage and identify trends.</li>
            <li>To protect the security and integrity of our Website.</li>
            <li>To comply with applicable legal and regulatory requirements.</li>
          </ul>

          <h5 className="fw-semibold mt-4 mb-3">
            9. Sharing of Your Personal Data
          </h5>
          <p className="text-muted">
            We may share your Personal Data only when necessary for operating
            our Website and providing our services. Information may be shared
            with trusted service providers who assist us with website
            operations, communication, analytics, or other business functions.
          </p>

          <p className="text-muted">
            We may also disclose information when required by law, government
            authorities, legal proceedings, or to protect the rights, property,
            and security of Chemo Biological Ltd., our users, or the public.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            10. Retention of Your Personal Data
          </h5>
          <p className="text-muted">
            Chemo Biological Ltd. will retain your Personal Data only for as
            long as necessary to fulfill the purposes described in this Privacy
            Policy, comply with legal obligations, resolve disputes, and
            enforce our agreements and policies.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            11. Transfer of Your Personal Data
          </h5>
          <p className="text-muted">
            Your information may be processed and stored at our offices or by
            service providers involved in operating our Website. By submitting
            your information, you consent to such processing where permitted
            by applicable law.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            12. Security of Your Personal Data
          </h5>
          <p className="text-muted">
            The security of your Personal Data is important to us. We use
            reasonable and commercially appropriate measures to protect your
            information. However, no method of transmission over the Internet
            or electronic storage is completely secure, and we cannot guarantee
            absolute security.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            13. Your Rights to Access, Update, or Delete Data
          </h5>
          <p className="text-muted">
            You may contact us to request access to, correction of, or deletion
            of Personal Data that you have provided to us. We may retain certain
            information where required by law or where we have a legitimate
            business or legal reason to do so.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            14. Children's Privacy
          </h5>
          <p className="text-muted">
            Our Website is not intended for children under the age of 13. We do
            not knowingly collect personally identifiable information from
            children under 13. If you believe that a child has provided us
            with Personal Data, please contact us so that appropriate action
            can be taken.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            15. Links to Other Websites
          </h5>
          <p className="text-muted">
            Our Website may contain links to third-party websites or services.
            We do not control these websites and are not responsible for their
            content, privacy policies, or practices. We recommend reviewing the
            privacy policy of every third-party website you visit.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            16. Changes to This Privacy Policy
          </h5>
          <p className="text-muted">
            We may update this Privacy Policy from time to time. Any changes
            will be published on this page along with an updated "Last
            updated" date. You are advised to review this Privacy Policy
            periodically for any changes.
          </p>

          <h5 className="fw-semibold mt-4 mb-3">
            17. Contact Us
          </h5>
          <p className="text-muted mb-2">
            If you have any questions or concerns regarding this Privacy
            Policy, you can contact us:
          </p>

          <p className="text-muted mb-1">
            <strong>Email:</strong>{" "}
            <a
              href="mailto:office.chemobiological@gmail.com"
              className="text-decoration-none"
            >
              office.chemobiological@gmail.com
            </a>
          </p>

          <p className="text-muted mb-0">
            <strong>Phone:</strong>{" "}
            <a
              href="tel:+917827552889"
              className="text-decoration-none"
            >
              +91 7827552889
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;